export function getEntryOrCreate<K, V>(map: Map<K, V>, key: K, valueFn: () => V): V {
  if (map == null) {
    throw new Error(`Argument with name 'map' must not be null or undefined`);
  }

  let internalValue = map.get(key);
  if (internalValue == null) {
    internalValue = valueFn();
    map.set(key, internalValue);
  }

  return internalValue;
}
